import { render, staticRenderFns } from "./MspForsageGroups.vue?vue&type=template&id=1266783a&scoped=true&"
import script from "./MspForsageGroups.vue?vue&type=script&lang=js&"
export * from "./MspForsageGroups.vue?vue&type=script&lang=js&"
import style0 from "./MspForsageGroups.vue?vue&type=style&index=0&id=1266783a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1266783a",
  null
  
)

export default component.exports